/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_Time_SmpteInputs */



/**
* | output |
* | --- |
* | "Time SMPTE" |
*
* @param {Markers_Export_Time_SmpteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_time_smpte = /** @type {((inputs?: Markers_Export_Time_SmpteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_Time_SmpteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Temps SMPTE")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeit SMPTE")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo SMPTE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время SMPTE")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo SMPTE")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间 SMPTE")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時間SMPTE")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय एसएमपीटीई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo SMPTE")
	return /** @type {LocalizedString} */ ("Time SMPTE")
});